/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Eingeladenespender1Inputs */



/**

* @param {_Field_Eingeladenespender1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_eingeladenespender1 = /** @type {((inputs?: _Field_Eingeladenespender1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Eingeladenespender1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Eingeladene Spender E-Mails")
});
export { _field_eingeladenespender1 as "_field_eingeladeneSpender" }